import { render, staticRenderFns } from "./skeletonCard.vue?vue&type=template&id=b5cd20be&scoped=true&"
import script from "./skeletonCard.vue?vue&type=script&lang=js&"
export * from "./skeletonCard.vue?vue&type=script&lang=js&"
import style0 from "./skeletonCard.vue?vue&type=style&index=0&id=b5cd20be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cd20be",
  null
  
)

export default component.exports